<template>
  <div id="content" class="dlnkmediatheque_my_mediatheque mb-6">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>

    <div class="position-relative bg-primary overflow-hidden">
      <div class="container position-relative z-index-2 space-top-1 space-top-md-1 space-bottom-1 space-bottom-md-1">
        <div class="w-md-80 w-xl-60 text-center mx-md-auto">
          <h1 class="text-white mb-4">Ma bibliothèque</h1>
        </div>
      </div>
      <figure class="position-absolute right-0 bottom-0 left-0 mb-n1">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1">
          <path fill="#F9F9F9" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path>
        </svg>
      </figure>
    </div>

    <div class="container bg-white py-2 border rounded">
      <!-- Nav tabs -->
      <ul class="nav nav-tabs mt-2" role="tablist">
        <li class="nav-item" role="presentation">
          <a class="nav-link active" id="loaned-tab" data-toggle="tab" href="#loaned_books" role="tab"
             aria-controls="home"
             aria-selected="true">Mes livres en prêt</a>
        </li>
        <li class="nav-item" role="reservation">
          <a class="nav-link" id="reservation-tab" data-toggle="tab" href="#reserved_books" role="tab"
             aria-controls="loans"
             aria-selected="false">Mes réservations</a>
        </li>
      </ul>

      <!-- Tab panes -->
      <div class="tab-content">

        <div class="tab-pane active" id="loaned_books" role="tabpanel" aria-labelledby="books-tab">
          <div class="row mt-2">

            <div class="col-12">

              <!-- books-->
              <div class="tab-wrapper">

                <table class="table">
                  <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Titre</th>
                    <th scope="col">État</th>
                    <th scope="col">Date Emprunt</th>
                    <th scope="col">Date Retour</th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr v-for="loan in loaned_books" :key="loan.id">
                    <th scope="row">
                      <img class="img-fluid rounded-lg" style="width: 4rem;"
                           :src="'/modules/dlnkmediatheque/actions/get_file.php?uuid=' + loan.book_uuid" alt="Book image">
                    </th>
                    <td>
                      <a :href="'/module/dlnkmediatheque/book?book_id=' + loan.book_id">{{ loan.book_title }}</a>
                    </td>
                    <td>{{ loan.loan_condition }}</td>
                    <td>{{ loan.loan_date }}</td>
                    <td>{{ loan.due_date }}</td>
                  </tr>

                  </tbody>
                </table>

              </div>
              <!-- End Books  -->

              <!-- Divider -->
              <div class="d-lg-none">
                <hr class="my-7 my-sm-11">
              </div>
              <!-- End Divider -->
            </div>
          </div>
        </div>

        <div class="tab-pane" id="reserved_books" role="tabpanel" aria-labelledby="loans-tab">

          <!-- Loans -->
          <div class="tab-wrapper">

            <table class="table">
              <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Titre</th>
                <th scope="col">Date de réservation</th>
                <th scope="col">Action</th>
              </tr>
              </thead>
              <tbody>

              <tr v-for="reservation in reserved_books" :key="reservation.id">
                <th scope="row">
                  <img class="img-fluid rounded-lg" style="width: 4rem;"
                       :src="'/modules/dlnkmediatheque/actions/get_file.php?uuid=' + reservation.book_uuid" alt="Book image">
                </th>
                <td>
                  <a :href="'/module/dlnkmediatheque/book?book_id=' + reservation.book_id">{{ reservation.book_title }}</a>
                </td>
                <td>{{ reservation.reservation_date }}</td>
                <td>
                  <a href="javascript:void(0);" class="btn btn-xs btn-icon btn-outline-danger rounded-circle"
                     data-toggle="tooltip" data-placement="top" title="Modifier le livre"
                     @click="delete_reservation(reservation.id)">
                    <i class="fas fa-trash"></i>
                  </a>

                </td>
              </tr>

              </tbody>
            </table>

          </div>
          <!-- End Loans  -->

        </div>

      </div>

      <a href="#" title="admin e-bibliotheque" class="btn btn-primary mb-4">
        Retour à la bibliothèque
      </a>


    </div>

  </div>

</template>

<script>

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {

  data: function () {
    return {
      loaned_books: Array(),
      reserved_books: Array(),
      message: "",
      message_type: "",
    }
  },

  mounted() {
    this.get_data()
  },

  methods: {

    close_message: function () {
      this.message = "";
      this.message_type = "";
    },

    delete_reservation(reservation_id) {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/my_mediatheque.php?reservation_id=' + parseInt(reservation_id);

      axios.delete(url)
          .then(function (response) {
            const status = response.data.status;

            if (status) {
              _this.message = "Réservation supprimé"
              _this.message_type = "alert-success"
              _this.get_data()
            } else {
              _this.message = "Erreur"
              _this.message_type = "alert-danger"
            }
          })
          .catch(function (error) {
            console.log(error);
            _this.message = "Erreur"
            _this.message_type = "alert-danger"
          })
          .then(function () {
            // always executed
          });
    },

    get_data: function () {
      let _this = this;

      let url = '/modules/dlnkmediatheque/actions/my_mediatheque.php';

      axios.get(url)
          .then(function (response) {
            _this.loaned_books = response.data.loans
            _this.reserved_books = response.data.reservations
          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    }
  },
}

</script>
